module.exports = __webpack_public_path__ + "static/img/12.c4405e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/4/zh/12.png
// module id = v+bf
// module chunks = 0